import { Component, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { AddApiSettingComponent } from './add-api-setting/add-api-setting.component';
import { EditApiSettingComponent } from './edit-api-setting/edit-api-setting.component';
import { HelperService } from '../core/services/helper.service';
import { BackendService } from '../core/services/backend-prod.service';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { HttpParams } from '@angular/common/http';
@Component({
  selector: 'app-api-settings',
  templateUrl: './api-settings.component.html',
  styleUrls: ['./api-settings.component.scss'],
})
export class ApiSettingsComponent implements OnInit {

  userDisplayedColumns: string[] = ['name', 'type', 'secret_expiry', 'action'];
  activeClients = [];
  hide1200 = false;
  page_min = 0;
  page_max = 10;
  loading = true;
  bubbleshow: boolean = false;
  ApiEditEnable = true;
  roleId

  constructor(
    private backendService: BackendService,
    private storage: Storage,
    private helperService: HelperService,
    private router: Router,
    private alertController: AlertController
  ) { }

  async getStorage() {
    let data = {
      token: await this.storage.get("token")
    }
    return data;
  }

  ngOnInit() {
    this.getAllClients();
  }

  getAllClients(){
    this.getStorage().then((res) => {
      this.helperService.loader()
      this.backendService.GetAPICall('listActiveClients', res.token).subscribe((data) => {
        this.helperService.closeLoader().then(() => {
          this.activeClients = data;
          this.activeClients.map((client) => {
            if ((new Date(client.secret_expiry)).getFullYear() - (new Date()).getFullYear() == 1) {
              client.secret_expiry = `${(new Date(client.secret_expiry)).getFullYear() - (new Date()).getFullYear()} year`
            }
            else {
              client.secret_expiry = `${(new Date(client.secret_expiry)).getFullYear() - (new Date()).getFullYear()} years`
            }
            return client;
          })
          this.loading = false;
        })
      })
    })
  }

  editClient(id: number) {
    this.router.navigate(['/baseapp/profile/edit-api', id]);
  }

  viewClient(id: number) {
    this.router.navigate(['/baseapp/profile/api-details', id]);
  }

  deleteClient(id: number) {
    this.getStorage().then((res) => {
      let params=new HttpParams().set('id',id)
      this.backendService.DeleteAPICall(`/api/users/deleteClientDetails`, res.token, params).subscribe((data) => {
        this.helperService.presentToast(data.msg, 2000);
        this.getAllClients();
      })
    })
  }

  async confirmDeleteAlert(id) {
    const alert = await this.alertController.create({
      header: 'Confirm',
      message: 'Are you sure you want to delete this client_id',
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteClient(id);
          },
        },
      ],
    });
    await alert.present();
  }



  closebubblecross() {
    this.bubbleshow = false;
  }

  closebubble() {
    this.bubbleshow = false;
  }
}





